import React from 'react'
import './Transscript.scss'
import TranscriptLine from './TranscriptLine/TranscriptLine'
import LanguageSelect from '../../../../LanguageSelect/LanguageSelect'
import { SearchBox } from 'office-ui-fabric-react/lib';
import DownloadDialog from './DownloadDialog'
import { CommandBarButton } from 'office-ui-fabric-react/lib/';
import { FontSizes, Text, ScrollablePane, mergeStyleSets, TooltipHost, TooltipDelay, Spinner, IconButton } from 'office-ui-fabric-react/lib';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Persona, PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import gql from "graphql-tag";
import zipcelx from 'zipcelx';
import Utils from "./../../../../common/Utils";
import { mutationWriteAuditEvent, getCognitiveServicesLocalesTranslation, getCognitiveServicesLocalesTranscription } from "../../../../../queries/querySettings";
import TranscriptSelect from './../../../../LanguageSelect/TranscriptSelect'
import { MyContext } from '../../../../../context';
import { Query } from "@apollo/react-components";
import AlertBar from '../../../../CustomComponents/AlertBar';


const config = {
    filename: 'conversationExport',
    sheet: {
        data: [
            [{
                value: 'id',
                type: 'string'
            },
            {
                value: "time",
                type: 'string'
            },
            {
                value: "speaker",
                type: 'string'
            },
            {
                value: "speakerId",
                type: 'string'
            },
            {
                value: "text",
                type: 'string'
            }]
        ]
    }
};

export default class Transscript extends React.Component {
    static contextType = MyContext;

    componentDidUpdate(prevProps) {
        if (this.props.data !== prevProps.data) {
            this.setState({ transcript: this.props.data.transcript });
        }
    }

    constructor(props) {
        super(props);
        this.findKeywordsInTranscript = this.findKeywordsInTranscript.bind(this);
        this.sortArr = this.sortArr.bind(this);
        this.convertArr = this.convertArr.bind(this);
    }

    state = {
        id: "0",
        val: "",
        transcript: null,
        translationActive: false,
        translated: false,
        language: null,
        languageCode: "",
        audioActive: this.props.onlyTag === true ? false : true,
        chatActive: this.props.onlyTag === true ? false : true,
        tagActive: true,
        attachActive: true,
        one2oneView: (this.props.user != null && this.props.user.filter(user => user.type !== "Bot").length == 2) ? true : false,
        exportDialogOpen: false,
        aiSummaryExpanded: true
    };

    lastSpeaker = "";
    handler(input) {
        this.setState({ id: "1", val: input })
    }

    onTranslate = async (language, languageText) => {
        this.setState({ translationActive: true });
        this.setState({ language: languageText });
        this.setState({ languageCode: language });

        var data = await this.props.client
            .query({
                query: gql`
                query ent ($input: AuthInput, $id : ID!, $language: String) {
                    getTranslation (input: $input, id: $id, language: $language) 
                    {
                        id         
                        unifiedTranscript
          	            {
                            language
                            transcript
              	            {
                                text
                                type
                                speakerId
                                speakerUserId 
                                url
                                instances
                  	            {
                                    start
                                    end
                                    adjustedStart
                                    adjustedEnd
                                }
                            }
                            speakers {
                               name
                            }
}
                    }
                }
                `,
                fetchPolicy: "network-only",
                variables: {
                    id: this.props.id, language: language, input: this.props.authorization
                }
            });
        this.setState({ translationActive: false });
        this.setState({ translated: true });
        this.setState({ transcript: data.data.getTranslation.unifiedTranscript.transcript });
    }


    findKeywords = () => {//TestFunction
        if (this.props.data != null && this.props.data.transcript !== undefined) {
            let out = [];
            for (let xx = 0; xx < this.props.data.transcript.length; xx++) {

                out.push(this.findKeywordsInTranscript(this.props.data.transcript[xx].text, this.props.data.transcript[xx].instances, this.sortArr(this.convertArr(this.props.sum.keywords))));
            }
        }
    };

    convertArr = (arr) =>//SummarizedInsight
    {
        let outPut = [];
        let tmpKey;

        for (let i = 0; i < arr.length; i++) {
            tmpKey = arr[i];
            let keywordCategory = arr[i].categorie;
            for (let j = 0; j < tmpKey.appearances.length; j++) {
                outPut.push({
                    name: tmpKey.name,
                    time: tmpKey.appearances[j].startSeconds,
                    betterTime: tmpKey.appearances[j].startTime,
                    trans: tmpKey.isTranscript,
                    categorie: keywordCategory,
                    hasSearchExactKeywords: tmpKey.hasSearchExactKeywords,
                    fromPolicy: tmpKey.fromPolicy,
                    policy: tmpKey.policy
                });
            }
        }

        return outPut;
    };

    SimpleTimeParser = (input) => {
        // changes in this method has been done for wrong conversion when receiving timestamp like 02:22 instead of 02:22.11223344 for ticket RI-12043

        let out = 0;
        let tmp = input.split(":");
        let tmp2 = [tmp[2], "0"];

        if (tmp[2].indexOf(".") !== -1) {
            tmp2 = tmp[2].split(".");
        }

        out = tmp[0] * 60 * 60 + tmp[1] * 60 + tmp2[0] * 1;

        if (tmp2.length > 1 && tmp2[1] !== "0") {
            out += (tmp2[1] / 10000000) //- 0.01;
        }

        return out;
    };
    sortArr = (arr) => {
        return arr.sort((a, b) => { return a.time - b.time });
    };

    getKeysForTranscript = (timeIn, timeOut, arr) => {

        return arr.filter((el) => {
            return Math.floor(el.time) >= Math.floor(timeIn) && (Math.floor(el.time) <= Math.floor(timeOut) || Math.floor(timeOut) < 0) && el.trans === true
        });
    };

    findKeywordsInTranscript = (text, instances, arr) => {
        //text is the block, instances time of the block, arr is array of keywords
        let out = [], tmp;
        // console.log(this.SimpleTimeParser(instances[0].adjustedStart)+" "+this.SimpleTimeParser(instances[0].adjustedEnd));
        //seacrh for keywords in the time of the block
        tmp = this.getKeysForTranscript(this.SimpleTimeParser(instances[0].adjustedStart), this.SimpleTimeParser(instances[0].adjustedEnd), arr);
        for (let i = 0; i < tmp.length; i++) {
            var keyword = "";
            var soundlike = "^";
            var keywordAndSoundlike = tmp[i].name?.split('_') ?? [''];
            keyword = keywordAndSoundlike[0];
            if (keywordAndSoundlike[1]) {
                soundlike = keywordAndSoundlike[1];
            }
            if ((text.toLowerCase().includes(keyword.toLowerCase())) || (text.toLowerCase().includes(soundlike.toLowerCase()))) {
                out.push(tmp[i]);
            }
            else {//console.log("#"+tmp[i].name)
            }

        }
        // console.log(tracscript.text);
        return out;


    }

    renderLines = (props) => {
        this.lastSpeaker = "";
        if ((this.state.transcript != null && this.state.transcript !== undefined)) {
            let languageDirection = "ltl";
            if (this.state.languageCode === "he" || this.state.languageCode === "ar") {
                languageDirection = "rtl";
            }
            return mergeReactionDuplicates(this.state.transcript).map(({ text, speakerId, speakerUserId, instances, type, url, changedNote, changedTime, priority, reactions, repliedOnContent, originalMessageSender, originalMessageId, messageId }, i) =>
            (
                this.getTranscriptLine(i, text, speakerId, speakerUserId, this.lastSpeaker, instances, this.state.languageCode, languageDirection, type, url, changedNote, changedTime, priority, reactions, repliedOnContent, originalMessageSender, originalMessageId, messageId)
            ));
        }
        else if ((this.props.data != null && this.props.data.transcript != null && this.props.data.transcript !== undefined)) {
            let languageDirection = "ltl";
            if (((this.props.data.language != null) && this.props.data.language.split("-")[0] === "he") || ((this.props.data != null && this.props.data.language != null && this.props.data.language.split("-")[0]) === "ar")) {
                languageDirection = "rtl";
            }
            return mergeReactionDuplicates(this.props.data.transcript).map(({ text, speakerId, speakerUserId, instances, type, url, changedNote, changedTime, priority, reactions, repliedOnContent, originalMessageSender, originalMessageId, messageId }, i) =>
            (
                this.getTranscriptLine(i, text, speakerId, speakerUserId, this.lastSpeaker, instances, this.props.data.language, languageDirection, type, url, changedNote, changedTime, priority, reactions, repliedOnContent, originalMessageSender, originalMessageId, messageId)
            ));
        }
        else if (this.props.data != null) {
            return <MyContext.Consumer>
                {(context) => (
                    <h3>{context.getTranslation("detailContainer", "transcriptNotPossible")}</h3>
                )
                }
            </MyContext.Consumer>
        }
        else {
            return <MyContext.Consumer>
                {(context) => (
                    <h3>{context.getTranslation("detailContainer", "noTranscriptData")}</h3>
                )
                }
            </MyContext.Consumer>
        }
    }

    getSpeakerNumberBasedOnUserId = (speakerId, userList, speakerIsUserId) => {
        //this is used only for 1 to 1 calls to searate left to right speakers
        //for new metadata version 1.2 speakerId is no longer used so a solution around speakerUserId is needed
        //speakerId is still used for old metadata versions
        if (speakerIsUserId) {
            let filteredUserList = userList.filter(user => user.type !== "Bot");

            if (!filteredUserList) {
                return 0;
            }

            const userIndex = filteredUserList.findIndex(user => user.userId === speakerId);
            return userIndex !== -1 ? userIndex : 0;
        } else {
            return speakerId
        }
    }

    getTranscriptLine = (i, text, speakerId, speakerUserId, lastSpeaker, instances, languageCode, languageDirection, type, url, changedNote, changedTime, priority, reactions, repliedOnContent, originalMessageSender, originalMessageId, messageId) => {
        if (this.state.id === "1" && this.state.val !== "") {
            if (!text.toLowerCase().includes(this.state.val.toLowerCase()))
                return;
        } else if ((type === "audio" || type === "") && (!this.state.audioActive || this.props.viewType === "liveView" || this.props.viewType === "attachView")) {
            return;
        } else if (type === "chat" && (!this.state.chatActive || this.props.viewType === "liveView" || this.props.viewType === "attachView")) {
            return;
        } else if ((type === "tag" || type === "rec") && (!this.state.tagActive || this.props.viewType === "attachView")) {
            return;
        } else if ((type === "attach") && (!this.state.attachActive || this.props.viewType === "liveView")) {
            return;
        }
        var speakerName = "";
        var speakerPhoto = null;
        var speakerIdVersion = speakerId;
        var speakerIsUserId = false;
        if (this.props.metadata.versionId >= "1.2" || (speakerUserId != undefined && speakerUserId != null && speakerUserId != "")) { //check if metadata version ahs unmixed audio and use speakerUserId. to make sure old version will work
            speakerIdVersion = speakerUserId;
            speakerIsUserId = true;
        }
        if (type === "audio")
            speakerName = getSpeakerName(speakerIdVersion, this.props.user, this.props.metadata.versionId, speakerIsUserId);
        else {
            speakerName = getSpeakerName(speakerIdVersion, this.props.user, this.props.metadata.versionId, speakerIsUserId);
            speakerPhoto = getSpeakerPhoto(speakerIdVersion, this.props.user, this.props.metadata.versionId, speakerIsUserId);
        }
        var lastSpeakerSave = lastSpeaker;
        this.lastSpeaker = speakerName;
        if (type === "rec")
            this.lastSpeaker = null;

        const isReply = originalMessageId != null && originalMessageId !== "" && repliedOnContent != null && repliedOnContent !== "";
        const originalMessage = isReply
            ? {
                text: repliedOnContent,
                author: originalMessageSender,
                messageId: originalMessageId
            }
            : null;

        return <TranscriptLine
            key={i}
            type={type}
            viewType={this.props.viewType}
            one2oneView={this.state.one2oneView}
            one2oneSide={this.state.one2oneView ? this.getSpeakerNumberBasedOnUserId(speakerIdVersion, this.props.user, speakerIsUserId) : 0}
            keyWords={this.props.sum != null ? (this.findKeywordsInTranscript(text, instances, this.sortArr(this.convertArr(this.props.sum.keywords)))) : []}
            policyResultAdherence={this.props.policyResultAdherence}
            listener={this.props.listener}
            text={this.state.translationActive ? "Translation to " + this.state.language + " running" : text}
            lastSpeaker={lastSpeakerSave}
            speakerId={speakerName}
            photo={speakerPhoto}
            instances={instances}
            translated={this.state.translated}
            languageCode={languageCode}
            languageDirection={languageDirection}
            url={url}
            changedNote={changedNote}
            changedTime={changedTime}
            priority={priority}
            reactions={reactions}
            usersList={this.props.user}
            repliedOnContent={repliedOnContent}
            originalMessageSender={originalMessageSender}
            originalMessage={originalMessage}
            originalMessageId={originalMessageId}
            messageId={messageId}
            showAbsoluteChatTimes={this.props.metadata.showAbsoluteChatTimes}
        />
    }

    showDownloadDialog = (button) => {
        //if convesation is in shared mode this will be hidden
        if (!this.props.isShared) {
            let conversationSafeAccess = this.props.userRules !== undefined
                && this.props.userRules !== null
                && this.props.userRules.ruleAccess.userSafe !== "No"; // No | Full | Restricted
            //check if the conversation is in safe and the user has the access to it
            if (this.props.metadata.conversationSafe && conversationSafeAccess) {
                let exportAllowedFromFolder = false;
                //case full
                if (this.props.userRules?.ruleAccess?.userSafe === "Full") {
                    exportAllowedFromFolder = true;
                }
                //case resricted 
                else if (this.props.userRules?.ruleAccess?.userSafe === "Restricted") {
                    //if in unallocated
                    if (this.props.metadata.conversationSafeFolders !== undefined && this.props.metadata.conversationSafeFolders.length === 0) {
                        exportAllowedFromFolder = true;
                    }
                    //if in a folder
                    else if (this.props.metadata.conversationSafeFolders !== undefined && this.props.metadata.conversationSafeFolders.length > 0) {
                        //if this detail view is opened from folder
                        if (this.props.openedFromFolder) {
                            exportAllowedFromFolder = this.props.userRules.visibilityExport
                        }
                        //if this detail view is opened NOT from folder
                        else {
                            exportAllowedFromFolder = true;
                        }

                    }
                }
                return window.innerWidth > 600
                    && ((button === "transcript" && this.props.isFullScreen) || (button === "export" && !this.props.isFullScreen))
                    && (this.props.userRules?.ruleAccess?.userDenyExport == null || !this.props.userRules?.ruleAccess?.userDenyExport) && exportAllowedFromFolder
            } else {
                return window.innerWidth > 600
                    && ((button === "transcript" && this.props.isFullScreen) || (button === "export" && !this.props.isFullScreen))
                    && (this.props.userRules?.ruleAccess?.userDenyExport == null || !this.props.userRules?.ruleAccess?.userDenyExport)
            }
        }
        return false;
    }



    renderAiSummary = () => {
        if (!this.props.aiSummary) {
            return null;
        }
        let answer = this.props.aiSummary;
        try {
            const parsed = JSON.parse(this.props.aiSummary);
            if (parsed && parsed.Answer) {
                answer = parsed.Answer;
            }
        } catch (e) {
            // If not valid JSON, display the raw string
        }
        return (
            <MyContext.Consumer>
                {(context) => (
                    <div style={{
                        margin: '10px',
                        padding: '10px',
                        boxShadow: 'rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px',
                        borderRadius: '2px'
                    }}>
                        <Stack horizontal verticalAlign="center">
                            <IconButton
                                iconProps={{ iconName: this.state.aiSummaryExpanded ? 'ChevronDown' : 'ChevronRight' }}
                                onClick={() => this.setState({ aiSummaryExpanded: !this.state.aiSummaryExpanded })}
                            />
                            <Text variant="mediumPlus" style={{ fontWeight: 'bold' }}>
                                {context.getTranslation("detailContainer", "aiSummaryTitle")}
                            </Text>
                        </Stack>
                        {this.state.aiSummaryExpanded &&
                            <div style={{ marginLeft: '32px', marginTop: '5px' }}>
                                <Text variant="medium" style={{ whiteSpace: 'pre-wrap' }}>
                                    {answer}
                                </Text>
                            </div>
                        }
                    </div>
                )}
            </MyContext.Consumer>
        );
    }

    renderHeader = () => {
        return (<MyContext.Consumer>
            {(context) =>
                <Stack vertical style={{ "margin": "10px" }} >
                    <Stack horizontal tokens={{ childrenGap: "20" }} horizontalAlign="space-between">
                        {this.showDownloadDialog("transcript") && <Stack.Item>
                            <CommandBarButton
                                iconProps={{ iconName: 'Download' }}
                                text={"Transcript"}
                                style={{ padding: "7px", cursor: "pointer", fontSize: FontSizes.Icon }}
                                onClick={this._onExport}
                            />
                        </Stack.Item>}
                        {window.innerWidth > 600 && this.props.userRules != null && this.props.userRules.ruleAnalytics != null && (!this.props.userRules.visibilityDetails || this.props.userRules.visibilityDetailsAnalyticsChange) &&
                            <TooltipHost content={context.getTranslation("detailContainer", "transcriptMessage")} hidden={Utils.lsGet("helpMode") === "false"} calloutProps={{ gapSpace: 0 }} delay={TooltipDelay.long} >
                                <Query
                                    query={getCognitiveServicesLocalesTranscription}
                                    variables={{}}
                                >
                                    {({ loading, error, data }) => {
                                        if (loading) {
                                            return (
                                                <div style={{ float: "left", marginLeft: "50px" }}>
                                                    <Spinner label={context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />
                                                </div>
                                            );
                                        }
                                        if (error) return <h4>Failed to connect</h4>;
                                        if (data.getTranscriptionLocales == null) {
                                            return <div />;
                                        }
                                        let transcriptLanguageList = [];

                                        if (data.getTranscriptionLocales != null) {

                                            let languageNames = new Intl.DisplayNames(['en'], { type: 'language' });
                                            for (var i = 0; i < data.getTranscriptionLocales.length; i++) {
                                                var countryName = languageNames.of(data.getTranscriptionLocales[i]);
                                                transcriptLanguageList.push({
                                                    key: data.getTranscriptionLocales[i],
                                                    text: countryName
                                                });
                                            }
                                        }

                                        return <TranscriptSelect
                                            className="Selector"
                                            language={(this.props.data != null && this.props.data.languageTranscript != null) ? this.props.data.languageTranscript : context.getTranslation("detailContainer", "select")}
                                            onTranslate={this.onTranscript}
                                            isSpeechToText={(this.props.userRules?.ruleAnalytics?.withTranscription) ? true : false}
                                            languageList={transcriptLanguageList}
                                        />

                                    }}

                                </Query>
                            </TooltipHost>}

                        {window.innerWidth > 600
                            && !this.props.isShared
                            && (!this.props.userRules?.visibilityDetails || this.props.userRules?.visibilityDetailsAnalyticsChange)
                            && (this.props.userRules?.ruleAnalytics !== null && this.props.userRules?.ruleAnalytics?.translationType !== "No")
                            && <Stack.Item >
                                <Query
                                    query={getCognitiveServicesLocalesTranslation}
                                    variables={{}}
                                >
                                    {({ loading, error, data }) => {
                                        if (loading) {
                                            return (
                                                <div style={{ float: "left", marginLeft: "50px" }}>
                                                    <Spinner label={context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />
                                                </div>
                                            );
                                        }
                                        if (error) return <h4>Failed to connect</h4>;
                                        if (data.getTranslatorLocales == null) {
                                            return <div />;
                                        }

                                        let translateLanguageList = [];

                                        if (data.getTranslatorLocales != null) {

                                            for (var i = 0; i < data.getTranslatorLocales.length; i++) {
                                                let translateLanguageData = JSON.parse(data.getTranslatorLocales[i]);

                                                translateLanguageList.push({
                                                    key: translateLanguageData.key,
                                                    text: translateLanguageData.text
                                                });
                                            }
                                        }

                                        return <LanguageSelect
                                            className="Selector"
                                            language={this.state.language != null ? this.state.language : ""}
                                            onTranslate={this.onTranslate}
                                            languageList={translateLanguageList}
                                        />

                                    }}

                                </Query>

                            </Stack.Item >}

                        {this.showDownloadDialog("export") && <Stack.Item>
                            <DownloadDialog
                                refetchQueryFields={this.props.refetchQueryFields}
                                client={this.props.client}
                                authorization={this.props.authorization}
                                export={this.props.export}
                            />
                        </Stack.Item>}
                        <Stack.Item grow="1">
                            <SearchBox
                                styles={{ root: { width: 200 } }}
                                placeholder={context.getTranslation("detailContainer", "search")}
                                /*onEscape={ev => {
                                    console.log('Custom onEscape Called');
                                }}
                                onClear={ev => {
                                    console.log('Custom onClear Called');
                                }}*/
                                onChange={(event, newValue) => (event?.persist(), this.handler(newValue))}
                            //onSearch={newValue => console.log('SearchBox onSearch fired: ' + newValue)}
                            //onFocus={() => console.log('onFocus called')}
                            //onBlur={() => console.log('onBlur called')}
                            />
                        </Stack.Item>
                    </Stack>
                    {this.props.metadata.errorSpeechToText &&
                        <Stack>
                            <Stack.Item>
                                <AlertBar message={context.getTranslation("detailContainer", "analysisError")} alertType={"error"} />
                            </Stack.Item>
                        </Stack>
                    }
                    <Stack>

                        {this.props.metadata.errorMessage != null && this.props.metadata.errorMessage.length > 0 && <AlertBar
                            message={"There was an error in the transcription process. Please retry manually if needed."}
                            alertType={"error"}
                        />}

                    </Stack>
                </Stack>}
        </MyContext.Consumer>);
    }

    renderHeaderAttach = (props) => {
        return (
            <MyContext.Consumer>
                {(context) => (
                    <Text variant="large" >{context.getTranslation("detailContainer", "attachments")}</Text>
                )
                }
            </MyContext.Consumer>
        );
    }

    renderParticipants = (props) => {
        let filteredByTypeUser = props.user.filter(user => user.type !== "Bot");
        return (
            <div className="transcript-persona">
                <Stack horizontal horizontalAlign="space-between" >
                    <Persona
                        key={0}
                        size={PersonaSize.size32}
                        className="margin_low"
                        text={filteredByTypeUser[0].name}
                        secondaryText={filteredByTypeUser[0].detail}
                        imageUrl={"data:image/jpeg;base64," + filteredByTypeUser[0].photo}>
                    </Persona>
                    <Persona
                        key={1}
                        size={PersonaSize.size32}
                        className="margin_low"
                        text={filteredByTypeUser[1].name}
                        secondaryText={filteredByTypeUser[1].detail}
                        imageUrl={"data:image/jpeg;base64," + filteredByTypeUser[1].photo}>
                    </Persona>
                </Stack>
            </div>
        );
    }

    onTranscript = async (language, languageText) => {
        const transText = this.state.transcript ? this.state.transcript : this.props.data.transcript

        const updatedTranscript = transText.map(item => ({
            ...item,
            text: "A reprocess is running"
        }));
        this.setState({ transcript: updatedTranscript })

        this.props.client
            .mutate({
                mutation: gql`
                        mutation ent ($uri: String, $id: String, $language: String, $type: String) {
                            analyzeConversation (uri: $uri, id: $id, language: $language, type: $type)
                     }
                     `,
                variables: {
                    uri: this.props.metadata.entryContent,
                    id: this.props.metadata.conversationId,
                    language: language,
                    type: (this.props.userRules != null && this.props.userRules.ruleAnalytics != null && this.props.userRules.ruleAnalytics.withTranscription) ? "SpeechToText" : "Indexer"
                }
            });
    }


    render() {
        var classNames = mergeStyleSets({
            wrapper: {
                height: this.props.height - 35,
                position: 'relative',
                minHeight: '200px'
            },
            pane: {
            }
        });

        if (this.props.viewType === "liveView" || this.props.viewType === "attachView") {
            return <MyContext.Consumer>
                {(context) => (
                    <Stack vertical>
                        <Text variant="large" >{context.getTranslation("liveViewPanel", "tagging")}</Text>
                        {window.innerWidth > 600 ?
                            <div className={classNames.wrapper}>
                                <ScrollablePane styles={{ root: classNames.pane }}>
                                    {this.renderLines(this.props)}
                                </ScrollablePane>
                            </div>
                            :
                            <div>
                                {this.renderLines(this.props)}
                            </div>
                        }
                    </Stack>
                )
                }
            </MyContext.Consumer>
        } else if (this.state.one2oneView === true) {
            classNames = mergeStyleSets({
                wrapperonetoone: {
                    height: this.props.height - 75,
                    position: 'relative',
                    minHeight: '200px'
                },
                pane: {
                }
            });

            return <Stack vertical >
                {this.renderHeader()}
                {this.renderAiSummary()}
                {this.renderParticipants(this.props)}
                {window.innerWidth > 600 ?
                    <div className={classNames.wrapperonetoone}>
                        <ScrollablePane styles={{ root: classNames.pane }}>
                            {this.renderLines(this.props)}
                        </ScrollablePane>
                    </div> :
                    <div>
                        {this.renderLines(this.props)}
                    </div>}
            </Stack>
        } else {
            return <div>
                {this.renderHeader()}
                {this.renderAiSummary()}
                {window.innerWidth > 600 ?
                    <div className={classNames.wrapper}>
                        <ScrollablePane styles={{ root: classNames.pane }}>
                            {this.renderLines(this.props)}
                        </ScrollablePane>
                    </div> :
                    <div>
                        {this.renderLines(this.props)}
                    </div>}
            </div>
        }
    }

    _onExport = async (ev) => {
        await this.props.client
            .mutate({
                mutation: mutationWriteAuditEvent,
                variables: {
                    key: "RECORDING_EXPORT",
                    id: this.props.export.conversationId,
                    text: ""
                }
            });
        var itemList = [];
        // Header
        itemList.push(config.sheet.data[0].slice());
        // Title
        itemList.push([
            {
                value: "title",
                type: 'string'
            }, {
                value: "",
                type: 'string'
            }, {
                value: "",
                type: 'string'
            }, {
                value: "",
                type: 'string'
            }, {
                value: this.props.export.topic,
                type: 'string'
            }]);
        // Date
        itemList.push([
            {
                value: "date",
                type: 'string'
            }, {
                value: "",
                type: 'string'
            }, {
                value: "",
                type: 'string'
            }, {
                value: "",
                type: 'string'
            }, {
                value: this.props.export.day,
                type: 'string'
            }]);
        // Time
        itemList.push([
            {
                value: "time",
                type: 'string'
            }, {
                value: "",
                type: 'string'
            }, {
                value: "",
                type: 'string'
            }, {
                value: "",
                type: 'string'
            }, {
                value: this.props.export.timein,
                type: 'string'
            }]);
        // Duration
        itemList.push([
            {
                value: "duration",
                type: 'string'
            }, {
                value: "",
                type: 'string'
            }, {
                value: "",
                type: 'string'
            }, {
                value: "",
                type: 'string'
            }, {
                value: this.props.export.duration,
                type: 'string'
            }]);
        // Conversation Id
        itemList.push([
            {
                value: "conversationid",
                type: 'string'
            }, {
                value: "",
                type: 'string'
            }, {
                value: "",
                type: 'string'
            }, {
                value: "",
                type: 'string'
            }, {
                value: this.props.export.conversationId,
                type: 'string'
            }]);
        // Language
        itemList.push([
            {
                value: "language",
                type: 'string'
            }, {
                value: "",
                type: 'string'
            }, {
                value: "",
                type: 'string'
            }, {
                value: "",
                type: 'string'
            }, {
                value: this.state.languageCode != null ? this.state.languageCode : this.props.data.language,
                type: 'string'
            }]);
        var i = 0;
        if (this.state.transcript != null) {
            mergeReactionDuplicates(this.state.transcript).forEach((anItem) => {
                var speakerIdVersion = anItem.speakerId;
                var speakerIsUserId = false;
                if (this.props.metadata.versionId >= "1.2" || (anItem.speakerUserId != undefined && anItem.speakerUserId != null && anItem.speakerUserId != "")) { //check if metadata version ahs unmixed audio and use speakerUserId. to make sure old version will work
                    speakerIdVersion = anItem.speakerUserId;
                    speakerIsUserId = true;
                }
                let speakerName = getSpeakerName(speakerIdVersion, this.props.user, this.props.metadata.versionId, speakerIsUserId);
                itemList.push([
                    {
                        value: i.toString(),
                        type: 'string'
                    }, {
                        value: anItem.instances[0].start,
                        type: 'string'
                    }, {
                        value: speakerName,
                        type: 'string'
                    }, {
                        value: speakerIdVersion,
                        type: 'string'
                    }, {
                        value: anItem.text,
                        type: 'string'
                    }]);
                i++;
            });
        } else {
            mergeReactionDuplicates(this.props.data.transcript).forEach((anItem) => {
                var speakerIdVersion = anItem.speakerId;
                var speakerIsUserId = false;
                if (this.props.metadata.versionId >= "1.2" || (anItem.speakerUserId != undefined && anItem.speakerUserId != null && anItem.speakerUserId != "")) { //check if metadata version ahs unmixed audio and use speakerUserId. to make sure old version will work
                    speakerIdVersion = anItem.speakerUserId;
                    speakerIsUserId = true;
                }
                let speakerName = getSpeakerName(speakerIdVersion, this.props.user, this.props.metadata.versionId, speakerIsUserId);
                itemList.push([
                    {
                        value: i.toString(),
                        type: 'string'
                    }, {
                        value: anItem.instances[0].start,
                        type: 'string'
                    }, {
                        value: speakerName,
                        type: 'string'
                    }, {
                        value: speakerIdVersion,
                        type: 'string'
                    }, {
                        value: anItem.text,
                        type: 'string'
                    }]);
                i++;
            });
        }
        config.sheet.data = itemList;
        zipcelx(config)
        this.setState({ isDialogOpen: true });
    }
}



const stripVolatileSrc = (text) => text?.replace(/\s*src="[^"]*"/g, "") ?? text

function mergeReactionDuplicates(transcript) {
    const indexByKey = new Map()
    const result = []
    transcript.forEach((element) => {
        const key = `${element.speakerUserId}|${element.type}|${element.instances?.[0]?.start}|${stripVolatileSrc(element.text)}`
        const existingIndex = indexByKey.get(key)
        if (existingIndex !== undefined) {
            result[existingIndex] = { ...result[existingIndex], reactions: element.reactions }
        } else {
            indexByKey.set(key, result.length)
            result.push(element)
        }
    })
    return result
}

function getSpeakerName(speakerId, userlist, metadataVersion, speakerIsUserId) {
    if (speakerIsUserId) {
        let filteredUser = userlist.find(user => user.userId === speakerId);

        if (filteredUser !== undefined && filteredUser !== null) {
            return filteredUser.name;

        } else {
            return "Speaker"
        }

    } else {
        if (userlist !== undefined && userlist[speakerId] !== undefined) {
            return userlist[speakerId].name;
        }
        else {
            return "Speaker #" + speakerId;
        }
    }

}

function getSpeakerPhoto(speakerId, userlist, metadataVersion, speakerIsUserId) {
    if (speakerIsUserId) {

        let filteredUser = userlist.find(user => user.userId === speakerId);

        if (filteredUser !== undefined && filteredUser !== null) {
            return filteredUser.photo;

        } else {
            return null;
        }

    } else {
        if (userlist !== undefined && userlist[speakerId] !== undefined) {
            return userlist[speakerId].photo;
        }
        else {
            return null;
        }
    }
}

